import { render } from "./FriendsAndFamilySection.vue?vue&type=template&id=0e08bea6"
import script from "./FriendsAndFamilySection.vue?vue&type=script&lang=js"
export * from "./FriendsAndFamilySection.vue?vue&type=script&lang=js"
script.render = render

export default script